<template>
<div class="main courseitem">
  <!-- <van-swipe v-if="banners" class="swipe" :autoplay="3000">
    <van-swipe-item v-for="(img,index) in banners" :key="index">
      <video v-if="img.mime == 'mp4'" controls preload="auto" :poster="img.cover">
          <source :src="img.url" type="video/mp4">
          您的浏览器不支持 HTML5 视频,请更换浏览器。比如 Chrome 、 Firefox 等主流浏览器。
      </video>
      <img v-else v-lazy="img.url" @click="previewSwiper(banners,index)">
    </van-swipe-item>
  </van-swipe> -->

  <div class="swipe">
    <van-swipe class="swipe" :autoplay="3000">
      <van-swipe-item>
        <img v-lazy="courseInfo.picture">
      </van-swipe-item>
    </van-swipe>
    <upload-file
      class="uploadBtn"
      :id="'upCover'"
      @callBackImgUrl="getCoverUrl"></upload-file>
    <van-button class="uploadBtn" type="primary" size="normal">上传封面</van-button>
  </div>
  <div class="bcw course-info">
    <header class="course-info__head">
      <h3>
        <input class="inputbox" type="text" v-model="courseInfo.title" style="width:100%;padding:.05rem;">
      </h3>      
      <div class="clear mtm mbm">
        <div class="clear left fs1 course-info__evaluate">
          <van-rate class="left" v-model="courseInfo.rating" :size="14" disabled-color="#FF6F0F" disabled />
          <span class="c9">评价{{ courseInfo.ratingNum }}</span>
          <span class="c9">参课{{ courseInfo.historyStudentNum }}人</span>
        </div>
        <div class="right c6 fs1">
          <span class="course-info__price"><input class="inputbox" type="number" v-model="courseInfo.price" style="width:80px;"></span> / {{ courseInfo.courseTimes }}课时
        </div>
      </div>
    </header>
        
    <footer class="mtm course-info__foot fs2">
      <van-row>
        <van-col span="6">课程时间</van-col>
        <van-col span="18">60分钟/课时</van-col>
      </van-row>
      <van-row class="mtm address">
        <van-col span="6">上课地点</van-col>
        <van-col span="14"> 
          <router-link :to="{ name: 'venue',params:{clubId:clubInfo.id}}" class="clear mtm"><div class="mbn blue">{{ clubInfo.title }}</div> </router-link>
          <span class="c6">{{ clubInfo.address }}</span>         
        </van-col>
        <van-col span="4" class="green">        
          <c-select
            text="选择"
            :actions="clubs"
            @select="selectType"
            class="type-select right"
          ></c-select>
        </van-col>
          <!-- <a :href="mapUrl" class="map c6"><i class="iconfont">&#xe635;</i></a> -->
      </van-row>
    </footer>
  </div>

  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">课程信息</h3>
    </div>
    <textarea class="inputbox fs2 mtm" rows="6" placeholder="内容信息" v-model="courseInfo.about"  style="width:100%;padding:.05rem;"></textarea>
  </div>

  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">学员评价</h3>
    </div>
    <div class="model-box__bd fs2 c6 mtm clear">
      <evaluate-card v-for="item in reviewList" :iteminfo="item" :key="item.id" :type="'manage'"></evaluate-card>      
    </div>
  </div>
  <!-- <div class="clear bcw buybar">
    <div class="buybar__content clear">
        <div class="left clear buybar__price fs2 c9">
            <div class="mbn">课程编辑请前往电脑端管理后台</div>
            <div class="">http://www.buole.com/admin</div>
        </div>
        <van-button type="warning" size="small" class="buybar__btn left" @click="subSave()">保存</van-button>
        <van-button v-if="courseInfo.status == 'closed'" type="default" size="small" class="bbuybar__btn right" disabled>已下架</van-button>
        <van-button v-else type="primary" @click="close(courseInfo.id)" size="small" class="buybar__btn right">下架</van-button>
    </div>
  </div> -->
  <div class="clear bcw buybar">
    <div class="buybar__content clear">
        <van-button type="primary" size="small" class="buybar__btn right mlm" @click="subSave()">保存</van-button>
        <van-button v-if="courseInfo.status != 'published'" type="primary" @click="close(courseInfo.id,'published','确定开课吗？')" size="small" class="buybar__btn right">开课</van-button>
        <van-button v-if="courseInfo.status == 'published'" type="warning" @click="close(courseInfo.id,'closed','是否要下架该课程？')" size="small" class="buybar__btn right">下架</van-button>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import {
  Rate,
  Row,
  Col,
  Popup,
  Swipe,
  SwipeItem,ImagePreview,Dialog,Field,Toast
} from 'vant';
import TheBuybar from '@/components/TheBuybar'
import EvaluateCard from '@/components/EvaluateCard'
import AvatarBox from '@/components/AvatarBox'
import AreaList from '@/assets/scripts/area'
import CSelect from "@/components/Select"
import UploadFile from '@/components/UploadFile'
import moment from 'moment'
moment.locale('zh-cn');
Vue.use(Rate).use(Row).use(Col).use(Popup).use(Swipe).use(SwipeItem).use(ImagePreview).use(Dialog).use(Field).use(Toast);

export default {
  name: 'CoachCourseManage',
  components: {
    TheBuybar,
    EvaluateCard,
    AvatarBox,
    CSelect,
    UploadFile
  },
  data() {
    return {
      courseInfo:{},  //课程
      clubInfo:{}, //俱乐部信息
      reviewList:{},  //评价列表
      mapUrl:'',  // 导航地图
      banners: {},  // 轮播图
      clubPopupShow:false,  //俱乐部列表
      orderTypes: [
        {
          name: "王者俱乐部",
          address: '黄河三路188号',
          id:1
        },
        {
          name: "起塔俱乐部",
          address: '黄河三路555号',
          id:2
        }
      ],
      clubs:[], //俱乐部列表
    }
  },
  created() {
      let _this = this;
      // 详情数据
      this.$http.get('club_pt_course_manage/getInfo?courseId=' + this.$route.params.courseId).then(res => {
        // console.log(res)
        if(!res.data.code){
        this.courseInfo = res.data.value.courseInfo  //课程信息
        if(this.courseInfo.about!='' && this.courseInfo.about!=null){
          this.courseInfo.about = res.data.value.courseInfo.about.replace(/<[^>]+>/g,'')  //课程信息
        }
        this.reviewList = res.data.value.reviewList  //评价列表
        
        if(this.courseInfo.pictures!=''){
          this.banners = JSON.parse(this.courseInfo.pictures) 
        }
        this.clubInfo = res.data.value.courseInfo.clubInfo      
        this.clubs = res.data.value.clubs     //俱乐部列表
        
        //this.mapUrl = 'https://apis.map.qq.com/tools/poimarker?type=1&keyword='+window.encodeURIComponent(this.clubInfo.title)+'&center='+ this.clubInfo.latitude + ',' + this.clubInfo.longitude +'&radius=1000&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'
        }else{
          Toast(res.data.message)
        }
      })
  },
  methods: {
    showPopup: function() {
      if(this.userPics.length > 0){
        this.popupShow = true;
      }
    },
    previewSwiper: function(imgs,index){
        //放大图片路径 拼成数组
        var arr=[];         
        imgs.forEach((item, index) => {
             if(item.mime!='mp4'){
                  arr.push(item.url);
              }  
        })
        // console.log(arr)
        ImagePreview(arr, index);
    },
    close:function(courseId,sta,title){
      //下架  开课
        Dialog.confirm({
            title: title,
        }).then(() => {
        // on confirm  下架
            this.$http.post('club_pt_course_manage/edit',{
              id:courseId,
              status:sta
            }).then(res => {
                // console.log(res)
                if(!res.data.code){
                    Toast.success('操作成功！')
                    this.courseInfo.status = sta            
                }else{
                    Toast.fail({
                        message:res.data.message
                    })                        
                }                 
            })
        }).catch(() => {
        // on cancel
        });        
    },
    selectType(item) {
      //select筛选
      this.clubInfo.title = item.name
      this.clubInfo.address = item.address
      this.clubInfo.id = item.clubId      
    },
    getCoverUrl: function(url){
      // 封面照片
      // console.log(url)
      this.courseInfo.picture = url.url;
    },
    subSave(){
      if(!this.courseInfo.title){
        Toast.fail('请填写标题'); return false;
      } 
      if(!this.courseInfo.price){
        Toast.fail('请填写价格'); return false;
      }
      if(!this.clubInfo.id){
        Toast.fail('请选择俱乐部'); return false;
      } 
      //提交保存、
      this.$http.post('club_pt_course_manage/edit',{
          id:this.$route.params.courseId,
          picture:this.courseInfo.picture,
          title:this.courseInfo.title,
          price:this.courseInfo.price,
          about:this.courseInfo.about,
          clubId:this.clubInfo.id,
        }).then(res => {
          // console.log(res)
          if(!res.data.code){
              Toast.success('保存成功！')
          }else{
              Toast.fail({
                  message:res.data.message
              })                        
          }                 
      })
    },
  }
}
</script>

<style lang="less" scoped>
.swipe{
  position: relative;
  height: 1.8rem;
  img{ width: 100%; height: 100%; object-fit: cover; }
  & .uploadBtn.upload-img__box{
    width: 100%;
    height: 100%;
    z-index: 3;
    opacity: 0;
  }
  & .uploadBtn{
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
  }
}

.courseitem {
    padding-bottom: 0.7rem;
}
.course-info {
    padding: 0.15rem;
    &__head {
        border-bottom: 0.01rem #f6f6f6 solid;
    }
    &__evaluate {
        line-height: 0.2rem;
        color: #FF6600;
        &>.van-rate{
          margin-right: .1rem;
        }
    }
    &__price {
        font-size: 0.18rem;
        color: #f44;
    }
    &__price:before {
        content: '¥';
        font-size: 0.12rem;
        margin-right: 0.02rem;
    }

    &__enrolled {
        border-bottom: 0.01rem #f6f6f6 solid;
        & > div:first-child {
            line-height: 0.3rem;
        }
        // &__users{
        //     // line-height: .3rem;
    }
    &__avatar {
        float: left;
        width: 0.3rem;
        height: 0.3rem;
        margin-left: -.05rem;
        background-color: #f6f6f6;
        border-radius: 50%;
        border: 0.02rem solid white;
        text-align: center;
        color: #ddd;
        overflow: hidden;
        & > .iconfont {
            font-size: 0.14rem;
        }
    }
    &__foot {
      &>.address{
        position: relative;
        & .map i{position: absolute;right:0.05rem;top: 50%;margin-top: -0.1rem;font-size: 0.2rem}        
      }      
    }
}
// 下架
// .buybar{
//     height: .65rem;
//     &__btn{
//         position: absolute;
//         right: .12rem;
//         top:.15rem;
//     }
// }

.inputbox{
  border: 0;
  background: #f5f5f5;
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CoachCourseManage.vue